import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class UTAmsIsfLogListItem extends SearchModelBase {
    
    id: number = 0;
    userId: string = '';
    title: string = '';
    siteType: string = '';
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 120, dataIndex: 'postDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 2, text: 'User Name', width: 80, dataIndex: 'userId'}),
        XCol.Create({ col: 3, text: 'Type', width: 80, dataIndex: 'siteType',align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Title', width: 500, dataIndex: 'title', defaultColumnFocus:true}),

    ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: UTAmsIsfLogListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: UTAmsIsfLogListItem[]) {
        return data.map((d: UTAmsIsfLogListItem, index: number) => ({
          ...d,
        }));
    }
    
    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
      postDate: {from: 'fromPostDate', to: 'toPostDate'},
    }
}
